export default class Access {
  constructor() {
    this.users = [];
    this.roles = [];
    this.permissions = [];
    this.tempEmailAvailability = false;
    this.tempEmail = null;
  }
}
